import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSearchInput} from "../abstract-search-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterSearchInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-search-input",
    styleUrls: ["./filter-search-input.component.scss"],
    templateUrl: "./filter-search-input.component.html"
})
export class FUIFilterSearchInputComponent extends FUIAbstractSearchInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
